import React, {useEffect, useState} from 'react';
import {StreamBankLink} from "../StreamBankLink";
import {service as UserService} from "../../../Services/UserService";
import {useUserProfileImage} from "../../../Hooks/useUserProfileImage";

export const UserTableColumn = (props) => {
    const { Value, showProfileImage = true } = props;
    
    const userId = Value?.userId ?? Value;

    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(Value?.userId ? Value : null);
    const userProfileImage = useUserProfileImage(user);
    
    const showNA = () => {
        setUser(null);
        setLoading(false);
    }
    
    useEffect(() => {
        (async () => {
            if (user === null || Number(user?.userId) !== Number(userId)) {
                try {
                    if (userId !== null) {
                        setUser((await UserService.FindById(userId, true))?.result);
                        setLoading(false);
                    } else {
                        showNA();
                    }
                } catch(e) {
                    console.log('Failed to load user:', e);
                    showNA();
                }
            }
        })();
    }, [user?.userId, userId]);
    
    if(loading) {
        return <span>Loading...</span>;
    }
    
    if(!user) {
        return <span>N/A</span>;
    }

    return <StreamBankLink
        className="sb-actionable-link"
        Href={"/users/" + userId}
    >
        {
            showProfileImage ? <div className="sb-account-icon">
                <img src={userProfileImage} alt=""/>
            </div> : null
        }
        {UserService.GetTitle(user)}
    </StreamBankLink>;
}
